export const lang = {
  locale: '中文',
  toolbar: {
    Login: '登录',
    Logout: '退出',
    Home: '首页',
    Profile: '个人资料',
    Register: '注册',
    Recovery: '密码重置',
    PasswordChange: '密码修改',
    UserCenter: '个人中心',
    Cancel: '取消',
    OK: 'OK',
    Submit: '提交',
    Save: '临时保存',
    Confirm: '确认',
    Columns: '显示列',
    AddMeta: '添加元数据',
    AddParagraph: '添加段落',
    AddPart: '添加小段',
    Add: '新增',
    Delete: '删除',
    Edit: '编辑',
    Modify: '修改',
    Preview: '预览',
    Details: '详情',
    Search: '检索',
    Select: '选择',
    Reset: '重置',
    About: '关于我们',
    Console: '控制台',
    TryIT: '立即体验',
    Chat: '聊天',
    Release: '发布',
    Restore: '恢复'
  },
  words: {
    newpassword: '新密码',
    password: '输入密码',
    password2: '再次输入密码',
    accountconfirm: '账户确认',
    accountconfirmpoint: '输入Email，确认账户是否存在',
    otherlogin: '其他登陆方式',
    member: '会员列表',
    stamp: '集戳功能使用状况',
    coupon: '优惠券使用状况',
    stampcode: '集戳代码发行',
    coupondef: '优惠券管理',
    nexttitle: 'SCWS 管理控制台',
    nextsubtitle: '新一代 SemcentCloud Web服务管理控制台',
    nextdescription: "<ul class='list-unstyled'><li>支持多语言</li><li>操作流程更简洁，清晰</li><li></li><li>交互反馈更明确</li><li>功能列表：<ul><li>会员管理</li><li>优惠券管理</li><li>集戳管理</li></ul></li><li>SemcentCloud提供的云服务的一元化管理后台。</li></ul>",
    cms: '内容管理系统',
    lms: '学习管理系统',
    ec: '电商管理系统',
    crm: '客户关系管理系统'
  },
  dict: {
    total: '总金额',
    subtotal: '折后金额',
    addr: '地址',
    init: '初期值',
    inc: '增加',
    rate: '比率',
    amount: '金额',
    way: '方式',
    pfromto: '价格范围',
    qfromto: '数量范围',
    initdate: '货号',
    initstock: '货号',
    stockavailable: '货号',
    itemcd: '货号',
    titleshort: '略称',
    colornm: '颜色',
    sizenm: '尺寸',
    unit: '单位',
    iprice: '进价',
    oprice: '售价',
    dprice: '表示价格',
    spec: '规格',
    taxtype: '纳税',
    taxrate: '税率',
    axb: '标尺',
    woc: '标重',
    province: '省',
    city: '市',
    contactaddr: '地址',
    contactmobile: '电话',
    contactname: '联系人',
    dashboard: "工作台",
    paragraph: "段落",
    showGallery: "显示图片",
    additional: "附带信息",
    result: "结果",
    autoJudge: "自动判分",
    username: "用户名",
    password: "密码",
    contact: "联系方式",
    history: "履历",
    name: "姓名",
    order: "顺序号",
    options: "选项",
    questiontype: "题型",
    answer: "答案",
    subject: "科目",
    email: "电子邮箱",
    education: "教育背景",
    school: "毕业学校",
    major: "专业",
    graduate: "毕业年月日",
    degree: "学历",
    description: "自我介绍",
    cert: "荣誉证书，如：英语4级，日语1级，综合奖学金...",
    experience: "工作经验",
    skill: "特长技能",
    hobby: "兴趣爱好",
    height: "身高",
    weight: "体重",
    marital: "婚姻状况",
    political: "政治面貌",
    intention: "求职意向",
    salary: "期望薪资",
    position: "岗位",
    workplace: "工作地",
    residential: "住宿要求",
    ethnic: "民族",
    quantity: "数量",
    telephone: "电话号码",
    mobile: "手机号码",
    account: "账户",
    estimate: "预计",
    actual: "实际",
    fee: "金额",
    score: "得分",
    judge: "结果",
    correct: "正确答案",
    totalScore: "总分",
    passScore: "及格线",
    updator: "更新者",
    date: "日期",
    reservedate: "预约时间",
    createdate: "创建时间",
    updatedate: "更新时间",
    timecycle: "周期",
    timestart: "开始时间",
    timeend: "结束时间",
    timestep: "间隔",
    timesteplimit: "上限",
    datetrans: "交易日",
    datestart: "开始日期",
    dateend: "结束日期",
    datefinish: "完成日期",
    dateissued: "发行日",
    dateused: "使用日",
    expire: "期限",
    status: "状态",
    basic: "基本信息",
    sex: "性别",
    birthday: "出生年月日",
    origin: "籍贯：xx省xx市",
    locate: "所在地/居住地：xx省xx市xx区",
    cardid: "卡号",
    title: "标题",
    details: "详情",
    stampid: "集戳号",
    gallary: "图片",
    text: "文本",
    subtitle: "副标题",
    id: "识别号",
    generate: "生成",
    template: "模板",
    block: "代码块",
    codetype: "代码类别",
    parameter: "参数",
    return: "返回值",
    datatype: "数据类型",
    condition: "条件",
    from: "起始",
    to: "结束",
    subscript: "下标",
    body: "正文",
    summary: "总结",
    tags: "标签",
    preface: "引言",
    category: "分类",
    dictionary: "字典",
    memo: "备注",
    code: "代码",
    value: "值",
    cname: "中文名称",
    jname: "日文名称",
    ename: "英文名称",
    kbn: "区分",
    ord: "显示顺",
    pid: "父ID",
    lv: "层级",
    target: "对象",
    type: "类别",
    supervisor: "负责人",
    invite: "用户邀请",
    cost: "工时",
    costest: "预估工时",
    costact: "实际工时",
    comment: "备注",
    staff: "业务员",
    staffto: "指派",
    priority: "优先度",
    notetag: "标签",
    flowtype: "申请类型",
    router: "路由",
    career: "业界",
    project: "项目",
    auth_group: "权限",
    auth_list: "列表",
    auth_view: "表示",
    auth_add: "追加",
    auth_edit: "修改",
    auth_del: "删除",
    auth_preview: "预览",
    auth_details: "详情",
    auth_import: "导入",
    auth_export: "导出",
    auth_setup: "设置"
  },
  msg: {
    toRecovery: '忘记密码？',
    toLogin: '已注册账户？',
    toRegister: '未注册账户？',
    toLogout: '确定要退出吗?',
    toPreview: '预览会重新生成数据，继续吗？',
    toDelete: '确定要删除吗?',
    toContinue: '确定要继续吗?',
    toOtherLogin: '持有cloud.semcent.com的账户?',
    toRestore: '读取自动保存数据吗？'
  },
  datatable: {
    info: '显示 _PAGES_ 页中的第 _PAGE_ 页,总 _MAX_ 条记录！',
    infoEmpty: '无数据'
  },
  error: {
    serverError: '服务器异常。请联系管理员。{error}',
    serverNormal: '服务器正常',
    notLtnM: '不得超过{n}M!',
    notAllowedFmt: '请选择图片！',
    invalid: '无效的{str}',
    required: '请输入{str}',
    notExistAccount: '用户不存在！',
    notAllowed: '{str},禁止删除或修改！',
    failed: '{str}失败！',
    failedLogin: '密码错误，请重试！',
    failedRequest: '请求失败： {err}'
  },
  info: {
    succeedRegister: '账户注册成功。\n跳转到登录画面！',
    succeedRegisterDup: '账户已存在。\n跳转到登录画面！',
    succeedToLogin: '登录成功！',
    succeedRequest: '数据请求成功！',
    succeedInsert: '追加成功！',
    succeedUpdate: '更新成功！',
    succeedDelete: '删除成功！',
    succeedSave: '保存成功！'
  },
  notice: {
    updatePost: '[{createdate}] {id}: <span class="text-info">{title}</span>は更新されました。',
    createReserve: '[{createdate}] 予約が入ってきました。',
    updateReserve: '[{createdate}] 予約番号:{id}は{status}に変更しました。',
    addStamp: '[{createdate}] {custname}様はスキャンでスタンプを受け取りました。stampid:{stampid}',
    addStampByCode: '[{createdate}] {custname}番号入力でスタンプを受け取りました。stampid:{stampid}'
  },
  title: {
    style: "样式",
    activity: "动态",
    menu: '菜谱',
    ec: '销售管理',
    depot: '仓库',
    supplier: '供应商',
    item: '商品',
    stock: '库存',
    discount: '折扣',
    freight: '运费',
    order: '订单',
    member: '会员',
    coupon: '优惠券',
    mntcoupon: '优惠券管理',
    stamp: '集戳',
    stampcode: '集戳代号',
    content: '内容管理',
    bucket: '存储桶',
    post: '帖子',
    groupware: '协同办公',
    report: '回执.汇报',
    message: '消息',
    notice: '公告',
    todo: '待办',
    crm: '客户管理',
    lms: '学习管理系统',
    test: '答题',
    template: '模板',
    construct: '构建',
    question: '题库',
    examresult: '测评结果',
    customer: '客户',
    contact: '联络人',
    case: '商机',
    note: '便签',
    record: '会议记录',
    flow: '请假申请',
    resource: '设备设施',
    reserve: '预约',
    schedule: '日程',
    calendar: '日历',
    faq: '客服系统',
    faqreply: '接入应答',
    consult: '咨询',
    document: '文档',
    product: '产品',
    solution: '解决方案',
    setting: '设置',
    information: '基本信息',
    role: '角色',
    roletarget: '角色对象关联',
    roleperm: '角色权限关联',
    perm: '权限',
    org: '组织',
    pos: '岗位',
    grp: '群组',
    user: '用户',
    grant: '授权',
    exam: "试卷"
  },
  faq: {
    msgWelcome: '欢迎{0}进入咨询系统.'
  },
  chat: {
    start: '开始',
    send: '发送',
    sendpromote: '请输入消息内容',
    sayto: '我对{0}说',
    say: '{0}说'
  }
}
